module.exports = __webpack_public_path__ + "static/img/10.edfb7b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/10.png
// module id = wme3
// module chunks = 0